"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const user_1 = require("selectors/user");
const view_utils_1 = require("utils/view-utils");
const person_photo_thumb_1 = __importDefault(require("../person-photo-thumb"));
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const delete_confirmation_1 = __importDefault(require("components/common/delete-confirmation"));
const popup_menu_1 = __importDefault(require("components/common/popup-menu"));
const households_1 = require("selectors/households");
require("./household-member-card.scss");
class HouseholdMemberCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showInviteDeleteConfirmation: false,
            showMemberDeleteConfirmation: false,
        };
    }
    resendInvite = () => {
        const { resendInvite, householdPerson } = this.props;
        resendInvite(householdPerson);
    };
    confirmDeleteInvite = (e) => {
        e.stopPropagation();
        this.setState({ showInviteDeleteConfirmation: true });
    };
    hideInviteDeleteConfirmation = () => {
        this.setState({ showInviteDeleteConfirmation: false });
    };
    deleteInvite = () => {
        const { deleteInvite, householdPerson } = this.props;
        this.hideInviteDeleteConfirmation();
        deleteInvite(householdPerson);
    };
    confirmDeleteMember = (e) => {
        e.stopPropagation();
        this.setState({ showMemberDeleteConfirmation: true });
    };
    deleteMember = () => {
        const { household, householdPerson, deleteHouseholdPerson } = this.props;
        this.hideMemberDeleteConfirmation();
        deleteHouseholdPerson(household, householdPerson);
    };
    hideMemberDeleteConfirmation = () => {
        this.setState({ showMemberDeleteConfirmation: false });
    };
    onMenuHide = () => {
        this.hideInviteDeleteConfirmation();
        this.hideMemberDeleteConfirmation();
    };
    onClick = () => {
        const { history, householdPerson, profile, setSelectedMember, loadContactInfos } = this.props;
        if (householdPerson.personId === profile.id) {
            history.push('/settings/profile');
        }
        else {
            setSelectedMember(householdPerson);
            return loadContactInfos(householdPerson.personId).then(() => {
                history.push('/settings/household/member');
            });
        }
    };
    renderMenu() {
        const { householdPerson, profile } = this.props;
        const { showInviteDeleteConfirmation, showMemberDeleteConfirmation } = this.state;
        const isLoggedInUser = householdPerson.personId === profile.id;
        const hasPendingInvite = (0, households_1.getHasPendingInvite)(householdPerson);
        const items = householdPerson.editable ? (React.createElement("div", null,
            React.createElement("div", { className: "PopupMenu-item", onClick: this.onClick },
                React.createElement(teamsnap_ui_1.Icon, { name: "edit" }),
                "Edit"),
            hasPendingInvite && (React.createElement("div", { className: "PopupMenu-item", onClick: this.resendInvite },
                React.createElement(teamsnap_ui_1.Icon, { name: "send" }),
                "Resend Invitation")),
            hasPendingInvite && (React.createElement("div", { className: "PopupMenu-item", onClick: this.confirmDeleteInvite },
                React.createElement(teamsnap_ui_1.Icon, { name: "dismiss" }),
                "Delete Invitation")),
            hasPendingInvite && showInviteDeleteConfirmation && (React.createElement(delete_confirmation_1.default, { onDelete: this.deleteInvite, onCancel: this.hideInviteDeleteConfirmation })),
            !isLoggedInUser && (React.createElement("div", { className: "PopupMenu-item u-colorNegative", onClick: this.confirmDeleteMember },
                React.createElement(teamsnap_ui_1.Icon, { name: "dismiss" }),
                "Remove")),
            showMemberDeleteConfirmation && (React.createElement(delete_confirmation_1.default, { onDelete: this.deleteMember, onCancel: this.hideMemberDeleteConfirmation, deleteText: "Remove" })))) : (React.createElement("div", { className: "PopupMenu-item", onClick: this.onClick },
            React.createElement(teamsnap_ui_1.Icon, { name: "preview" }),
            "View"));
        return (React.createElement(popup_menu_1.default, { title: "\u2022\u2022\u2022", className: "menu menu-ellipsis", onHide: this.onMenuHide }, items));
    }
    render() {
        const { householdPerson, profile } = this.props;
        let name = '';
        let isOrganizer = false;
        if (householdPerson) {
            name = (0, view_utils_1.fullName)(householdPerson.person);
            isOrganizer = householdPerson.isOrganizer;
        }
        else if (profile) {
            name = (0, view_utils_1.fullName)(profile);
            isOrganizer = true;
        }
        return (React.createElement("div", { className: "Grid-cell u-xs-size1of2 u-sm-size1of3 u-padBottomMd" },
            React.createElement("div", { className: "Member", onClick: this.onClick },
                this.renderMenu(),
                React.createElement("div", { className: "Member-photo" },
                    React.createElement(person_photo_thumb_1.default, null)),
                React.createElement("div", { className: "Member-name" }, name),
                React.createElement("div", { className: "Member-info" },
                    isOrganizer ? 'Organizer' : (0, user_1.ageGroup)(householdPerson.person.birthdate),
                    (0, households_1.getHasPendingInvite)(householdPerson) && '  |  Invitation Pending'))));
    }
}
exports.default = HouseholdMemberCard;
